<template>
  <div id="quitApply">
    <div class="header">
      <Form
        :label-width="90"
        inline
        :model="params"
        ref="paramsForm"
        style="width: 100%"
      >
        <Row>
          <Col span="5">
            <FormItem label="业务员" prop="nameOrCode">
              <Input
                style="width: 162px"
                v-model.trim="params.nameOrCode"
                placeholder="请输入业务员姓名/代码"
              />
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="所属机构" prop="deptCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.deptCode"
                @on-change="changeDept"
              >
                <Option
                  v-for="item in transForList.customList"
                  :value="item.deptCode"
                  :key="item.id"
                  placeholder="请选择机构名称/代码"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem
              label="审核状态"
              prop="approvalStatus"
              placeholder="请选择审核状态"
            >
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.approvalStatus"
              >
                <Option value="0">通过</Option>
                <Option value="1">未通过</Option>
                <Option value="2">审批中</Option>
                <!-- <Option value="3">待提交</Option> -->
                <Option value="4">已撤回</Option>
                <!-- <Option value="6">已失效</Option> -->
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="职级" prop="rankCode">
              <Select
                clearabletransfer
                @on-open-change="selectUpDown"
                v-model.trim="params.rankCode"
                placeholder="请选择职级名称"
              >
                <Option
                  :value="item.rankCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col style="float: right">
            <Button type="primary" @click="search">查询</Button>
            <Button @click="reset">重置</Button>
          </Col>
        </Row>
        <div style="margin-bottom: 20px">
          <div id="moreBtn" class="searchUpDownBtn" style="margin-bottom: 6px">
            <Icon type="ios-arrow-down" @click="moreFun()" />
            <span @click="moreFun()">更多条件</span>
          </div>
          <div id="moreCondition">
            <Row>
              <!-- <Col span="5">
                                <FormItem label="生效日期" prop="effectiveDate">
                                    <DatePicker type="date" @on-change="(val) =>{params.effectiveDate = val}" transfer v-model="params.effectiveDate" placeholder="请选择生效日期" ></DatePicker>
                                </FormItem>
                            </Col> -->
              <Col span="10">
                <FormItem label="日期类型" prop="dateType">
                  <Select
                    clearable
                    transfer
                    @on-open-change="selectUpDown"
                    v-model.trim="params.dateType"
                    placeholder="请选择日期类型"
                  >
                    <Option value="1">提交日期</Option>
                    <Option value="2">审批日期</Option>
                  </Select>
                  <DatePicker
                    transfer
                    type="daterange"
                    :value="params.date"
                    @on-change="
                      (date) => {
                        params.date = date;
                        params.startDate = date[0];
                        params.endDate = date[1];
                      }
                    "
                    placeholder="请选择日期范围"
                    style="margin-left: 8px"
                  ></DatePicker>
                </FormItem>
              </Col>
            </Row>
          </div>
          <div id="upBtn" class="searchUpDownBtn">
            <Icon type="ios-arrow-up" @click="upFun()" />
            <span @click="upFun()">收起</span>
          </div>
        </div>
      </Form>
    </div>
    <div style="margin-bottom: 15px">
      <Button
        type="primary"
        @click="quitApply('add')"
        v-if="button.moveApply_addRelationShip"
        >新增申请</Button
      >
      <Button type="warning" @click="agentCancel">一键撤回</Button>
    </div>
    <div>
      <primaryTable
        :columns="columns"
        :data="data"
        :total="total"
        :loading="tableLoading"
        @on-change="changePage"
        @on-page-size-change="changeSize"
      ></primaryTable>
    </div>

    <Modal
      class="Modal_html"
      :footer-hide="isSee"
      title="关系调整申请"
      v-model.trim="quitModalFlag"
      width="1000"
      @on-visible-change="(val) => cancel('formValidate_relation', val)"
    >
      <Form
        ref="formValidate_relation"
        :model="formValidate_relation"
        :rules="ruleValidate_leave"
        :label-width="120"
        :disabled="isSee"
      >
        <!-- 基本信息 -->
        <Row>
          <!-- <h3 class="marginLeft30" style="margin-left:20px;margin-bottom: 10px">提交信息</h3> -->
          <Col span="12">
            <FormItem label="业务员" prop="agentCode">
              <!-- <InputModal
                :disabled="isReady || isEdit"
                :rule="{
                  required: true,
                  message: ' 请选择业务员',
                  trigger: 'blur,change',
                }"
                value="agentCode"
                :ApiList="[
                  { agentCode: 'agentCode' },
                  { agentName: 'agentName' },
                  { rankCode: 'rankCode' },
                  { deptCode: 'customerCode' },
                  { areaCode: 'areaCode' },
                  { teamCode: 'teamInfoCode' },
                  { teamName: 'teamName' },
                  { groupCode: 'groupInfoCode' },
                  { groupName: 'groupInfoName' },
                  { areaName: 'areaName' },
                  { deptName: 'customerName' },
                  { rankName: 'rankName' },
                  { postName: 'postName' },
                  { postCode: 'postCode' },
                  { oldRecommender: 'additionName' },
                  { oldRecommenderCode: 'additionCode' },
                  { oldRelation: 'cultivateName' },
                  { oldRelationCode: 'cultivateId' },
                ]"
                :form.sync="formValidate_relation"
              ></InputModal> -->
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.agentCode"
                :disabled="isReady"
                @on-change="changePerson"
              >
                <Option
                  :value="item.agentCode"
                  v-for="(item, index) in personList"
                  :key="index"
                  >{{ item.agentCode }} / {{ item.agentName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="12">
            <FormItem label="业务员姓名" prop="agentName">
              <Input v-model.trim="formValidate_relation.agentName" disabled />
            </FormItem>
          </Col> -->
          <Col span="12">
            <FormItem label="职级" prop="rankCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.rankCode"
                ref="changeRank"
                disabled
                @on-change="changeRank"
              >
                <Option
                  :value="item.rankCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="所属机构" prop="deptCode">
              <Input
                type="text"
                disabled
                v-model="formValidate_relation.deptCodeAndName"
                placeholder="请输入"
              />
              <!-- <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.deptCode"
                ref="changeRank"
                disabled
              >
                <Option
                  v-for="item in transForList.customList"
                  :value="item.deptCode"
                  :key="item.id"
                  placeholder="请选择机构名称/代码"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select> -->
            </FormItem>
          </Col>
          <!-- 营业区4  营业部5 -->
          <!-- <Col span="12">
            <FormItem label="营业区/代码" prop="areaCode">
              <Select
                transfer
                @on-open-change="selectUpDown"
                disabled
                v-model.trim="formValidate_relation.areaCode"
                @on-change="
                  (data) => {
                    getChildById(data, 'teamList', 'teamName', '', '', 5);
                  }
                "
                clearable
                placeholder="请选择所属营业区"
              >
                <Option
                  :value="item.marketCode"
                  :key="item.marketCode"
                  v-for="item in areaList"
                  >{{ item.marketName }} / {{ item.marketCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="营业部/代码" prop="teamCode">
              <Select
                transfer
                @on-open-change="selectUpDown"
                disabled
                clearable
                placeholder="请选择所属营业部"
                v-model.trim="formValidate_relation.teamCode"
              >
                <Option
                  :value="item.marketCode"
                  :key="item.marketCode"
                  v-for="item in teamList"
                  >{{ item.marketName }} / {{ item.marketCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="营业组/代码" prop="groupCode">
              <Select
                transfer
                @on-open-change="selectUpDown"
                disabled
                v-model.trim="formValidate_relation.groupCode"
                placeholder="请输入营业组"
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in groupList"
                  :key="index"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col> -->
        </Row>

        <Row>
          <h3
            class="marginLeft30"
            style="margin-left: 20px; margin-bottom: 10px"
          >
            推荐关系
          </h3>
          <!-- <Col span="12">
            <FormItem label="原推荐人代码" prop="oldRecommenderCode">
              <Input
                v-model.trim="formValidate_relation.oldRecommenderCode"
                disabled
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="原推荐人姓名" prop="oldRecommender">
              <Input
                v-model.trim="formValidate_relation.oldRecommender"
                disabled
              />
            </FormItem>
          </Col> -->

          <!-- <Col span="12">
            <FormItem
              label="新推荐人代码"
              prop="changeRelationDTO.newRecommenderCode"
            >
              <InputModal
                :curAgentCode="formValidate_relation.agentCode"
                :disabled="isReady"
                :rule="{
                  required: true,
                  message: '请填写新推荐人',
                  trigger: 'blur,change',
                }"
                value="newRecommenderCode"
                :ApiList="[
                  { newRecommenderCode: 'agentCode' },
                  { newRecommender: 'agentName' },
                ]"
                :form.sync="formValidate_relation.changeRelationDTO"
              ></InputModal>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem
              label="新直接推荐人姓名"
              prop="changeRelationDTO.newRecommender"
            >
              <Input
                disabled
                v-model.trim="
                  formValidate_relation.changeRelationDTO.newRecommender
                "
              />
            </FormItem>
          </Col> -->
          <Col span="12">
            <FormItem label="原推荐人代码" prop="oldRecommenderCode">
              <Input
                v-model.trim="formValidate_relation.oldRecommenderCode"
                disabled
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="原推荐人姓名" prop="oldRecommender">
              <Input
                v-model.trim="formValidate_relation.oldRecommender"
                disabled
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem
              label="新直接推荐人"
              prop="changeRelationDTO.newRecommenderCode"
            >
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="
                  formValidate_relation.changeRelationDTO.newRecommenderCode
                "
                ref="changeRank"
                :disabled="isReady"
                @on-change="changeReferences($event, '1')"
              >
                <Option
                  :value="item.agentCode"
                  v-for="(item, index) in personList"
                  :key="index"
                  :v-if="formValidate_relation.agentCode"
                  :disabled="
                    item.agentCode.length == 5 ||
                    item.agentCode == formValidate_relation.agentCode
                  "
                  >{{ item.agentCode }} / {{ item.agentName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="12">
            <FormItem label="新间接推荐人">
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.agentCode"
                ref="changeRank"
                :disabled="isReady || isEdit"
                @on-change="changeReferences($event, '2')"
              >
                <Option
                  :value="item.agentCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="新三代推荐人">
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.agentCode"
                ref="changeRank"
                :disabled="isReady || isEdit"
                @on-change="changeReferences($event, '3')"
              >
                <Option
                  :value="item.agentCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="新四代推荐人">
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_relation.agentCode"
                ref="changeRank"
                :disabled="isReady || isEdit"
                @on-change="changeReferences($event, '4')"
              >
                <Option
                  :value="item.agentCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col> -->
          <Col span="24">
            <FormItem label="">
              <p style="color: red">
                注意：新推荐人与原推荐人不可相同，请慎重选择。
              </p>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="生效日期">
              <DatePicker
                disabled
                transfer
                type="date"
                v-model="formValidate_relation.effectiveDate"
                clearable
                @on-change="
                  (val) =>
                    (formValidate_relation.effectiveDate =
                      val === '' ? '' : val)
                "
                style="width: 100%"
                :options="options1"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row>
          <h3
            class="marginLeft30"
            style="margin-left: 20px; margin-bottom: 10px"
          >
            育成关系
          </h3>
          <Col span="12">
            <FormItem label="原育成人代码" prop="oldRelationCode">
              <Input
                v-model.trim="formValidate_relation.oldRelationCode"
                disabled
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="原育成人姓名" prop="oldRelation">
              <Input
                v-model.trim="formValidate_relation.oldRelation"
                disabled
              ></Input>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem
              label="新育成人代码"
              prop="changeRelationDTO.newRelationCode"
            >
              <InputModal
                :disabled="isReady"
                :rule="{
                  required: true,
                  message: '请填写新育成人',
                  trigger: 'blur,change',
                }"
                value="newRelationCode"
                :ApiList="[
                  { newRelationCode: 'agentCode' },
                  { newRelation: 'agentName' },
                ]"
                :form.sync="formValidate_relation.changeRelationDTO"
              ></InputModal>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="新育成人姓名" prop="changeRelationDTO.newRelation">
              <Input
                disabled
                v-model.trim="
                  formValidate_relation.changeRelationDTO.newRelation
                "
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="生效日期" prop="changeRelationDTO.effectiveDate">
              <DatePicker
                disabled
                transfer
                type="date"
                v-model="formValidate_relation.effectiveDate"
                clearable
                @on-change="
                  (val) =>
                    (formValidate_relation.effectiveDate =
                      val === '' ? '' : val)
                "
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row> -->
        <!-- <Row>
          <h3
            class="marginLeft30"
            style="margin-left: 20px; margin-bottom: 10px"
          >
            附件
          </h3>
        </Row>
        <div>
          <FormItem
            class="fileStyle"
            label="上传文件"
            prop="changeAttachmentDTO"
          >
            <div style="display: flex; flex-wrap: wrap">
              <span
                v-for="(
                  item, index
                ) in formValidate_relation.changeAttachmentDTO"
                :key="index"
              >
                <div class="demo-upload-list">
                  <img
                    :src="
                      $api.imgLoadUrl + item.filePath + '?sid=' + headers.sid
                    "
                  />
                  <div class="demo-upload-list-cover">
                    <Icon
                      type="ios-eye-outline"
                      @click.native="handleView(item)"
                    ></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native="delFormValidate_relationImage(item, index)"
                    ></Icon>
                  </div>
                </div>
                <div
                  style="text-align: center; width: 200px"
                  class="ellipsis"
                  :title="item.fileName"
                >
                  {{ item.fileName }}
                </div>
              </span>
            </div>
          </FormItem>
        </div>
        <Row v-if="!isSee">
          <FormItem label="">
            <div v-if="formValidate_relation.changeAttachmentDTO.length < 20">
              <Upload
                :action="action"
                ref="upload"
                name="files"
                :show-upload-list="false"
                :format="['jpg', 'pdf', 'png']"
                :headers="headers"
                type="drag"
                :on-success="handSuccess"
                accept=".jpg,.pdf,.png"
                :data="fileData"
              >
                <div style="height: 90px">
                  <Icon
                    type="ios-cloud-upload"
                    size="22"
                    style="color: #3399ff"
                  ></Icon>
                  <p>支持jpg/png格式图片；支持PDF文件</p>
                </div>
              </Upload>
            </div>
          </FormItem>
        </Row> -->
        <Row>
          <Col span="12">
            <FormItem label="申请提交人">
              <Input
                type="text"
                v-model.trim="
                  formValidate_relation.changeRelationDTO.createdUser
                "
                disabled
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="提交日期" prop="submitDate" disabled>
              <DatePicker
                transfer
                type="date"
                clearable
                :value="formValidate_relation.submitDate"
                :on-change="
                  (date) => {
                    formValidate_relation.submitDate = date;
                  }
                "
                placeholder="请输入"
                disabled
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancel('formValidate_relation', false)">取消</Button>
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="submit('0')"
          v-if="!isReady && !isEdit"
          >确认提交</Button
        >
        <!-- <Button type="primary" ghost @click="submit('1')"  v-if="!isReady && !isEdit">保存</Button> -->
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="resubmit('0')"
          v-if="isEdit"
          >再次提交</Button
        >
      </div>
    </Modal>

    <Modal v-model.trim="auditModal" title="审批记录" width="900">
      <Row>
        <Col>
          <ModalLog
            :auditList="auditList"
            checkLogType="审批记录"
            :auditNo="auditNo"
          ></ModalLog>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "rankMove",
  props: {
    headers: {
      type: Object,
    },
    sid: {
      type: String,
    },
    companyList: {
      type: Object,
    },
  },
  data() {
    const dateChange = (rule, value, callback) => {
      console.log(value);
      if (value === "" || value === null || value === undefined) {
        callback(new Error("请选择生效日期"));
      } else {
        callback();
      }
    };
    return {
      button: this.$store.state.app.button,
      auditModal: false,
      auditList: [],
      auditNo: "",
      isEdit: false,
      //上传的文件类型
      fileData: {
        fileType: 3,
      },
      //search 表单
      params: {
        page: 1,
        pageSize: 10,
        nameOrCode: "",
        deptCode: "",
        approvalStatus: "",
        dateType: "",
        date: [],
        startDate: "",
        endDate: "",
        //提交日期
        submissionFormDate: "",
        submissionToDate: "",
        //审核日期
        approvalFormDate: "",
        approvalToDate: "",
        //生效日期
        effectiveDate: "",
        effectiveFormDate: "",
        effectiveToDate: "",
      },
      isReady: false,
      isSee: false,
      action: this.$api.enclosureUpload,
      IsUpload: false,
      areaList: [],
      groupList: [],
      teamList: [],
      rankTypeList: [],
      customList: [],
      formValidate_relation: {
        effectiveDate: "",
        oldRecommender: "", //原推荐人临时
        oldRecommenderCode: "", //原推荐人临时
        oldRelation: "", // "原育成人",
        oldRelationCode: "", // "原育成人编码",
        changeType: 2, //异动类型 1-离职；2-关系；3-调动；4-合并
        agentCode: "",
        agentName: "",
        deptCode: "",
        deptName: "",
        groupCode: "",
        groupName: "",
        teamCode: "",
        teamName: "",
        areaCode: "",
        areaName: "",
        postName: "",
        postCode: "",
        submitDate: "",
        changeRelationDTO: {
          oldRecommender: "", //"原推荐人",
          oldRecommenderCode: "", // "原推荐人编码",
          oldRelation: "", // "原育成人",
          oldRelationCode: "", // "原育成人编码",
          newRecommender: "", // "新推荐人",
          newRecommenderCode: "", // "新推荐人编码",
          newRelation: "", //"新育成人",
          newRelationCode: "", //"新育成人编码"
        },
        changeAttachmentDTO: [],
      },
      ruleValidate_leave: {
        agentCode: [
          { required: true, message: "请选择业务员", trigger: "change,blur" },
        ],
        rankCode: [
          { required: true, message: "请选择职级", trigger: "change,blur" },
        ],
        deptCode: [
          {
            required: true,
            message: "请选择机构编码/名称",
            trigger: "change,blur",
          },
        ],
        effectiveDate: [
          { required: true, validator: dateChange, trigger: "change,blur" },
        ],
        changeAttachmentDTO: [
          /*  {required:true} */
        ],
        "changeRelationDTO.newRecommenderCode": [
          {
            required: true,
            message: "请选择新直接推荐人",
            trigger: "change,blur",
          },
        ],
      },
      quitModalFlag: false,
      total: 0,
      tableLoading: false,
      data: [
        {
          auditCode: "123",
        },
      ],
      columns: [
        {
          title: "审批编号",
          key: "approvalId",
          align: "center",
          // fixed:'left',
          minWidth: 100,
          render: (h, p) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.quitApply("ready", p.row);
                  },
                },
              },
              p.row.approvalId
            );
          },
        },
        {
          title: "业务员代码 ",
          key: "agentCode",
          align: "center",
          minWidth: 110,
        },
        {
          title: "业务员名称 ",
          key: "agentName",
          align: "center",
          minWidth: 110,
        },
        // {
        //     title:'管理机构代码',
        //     key:'deptCode',
        //     align:'center',
        //     minWidth:150
        // },
        {
          title: "所属机构名称",
          key: "ascriptionDeptName",
          align: "center",
          minWidth: 150,
        },
        // {
        //     title:'营业区代码',
        //     key:'areaCode',
        //     align:'center',
        //     minWidth:110
        // },
        // {
        //     title:'营业区名称',
        //     key:'areaName',
        //     align:'center',
        //     minWidth:110
        // },
        // {
        //     title:'营业部代码',
        //     key:'teamCode',
        //     align:'center',
        //     minWidth:110
        // },
        // {
        //     title:'营业部名称',
        //     key:'teamName',
        //     align:'center',
        //     minWidth:110
        // },

        {
          title: "职级",
          key: "rankName",
          align: "center",
          minWidth: 100,
        },
        // {
        //     title:'原推荐人代码',
        //     key:'oldRecommenderCode',
        //     align:'center',
        //     minWidth:120
        // },
        // {
        //     title:'原推荐人姓名',
        //     key:'oldRecommender',
        //     align:'center',
        //     minWidth:120
        // },
        // {
        //     title:'新推荐人代码',
        //     key:'newRecommenderCode',
        //     align:'center',
        //     minWidth:120
        // }, {
        //     title:'新推荐人姓名',
        //     key:'newRecommender',
        //     align:'center',
        //     minWidth:120
        // },
        // {
        //     title:'原育成人代码',
        //     key:'oldRelationCode',
        //     align:'center',
        //     minWidth:120
        // },
        // {
        //     title:'原育成人姓名',
        //     key:'oldRelation',
        //     align:'center',
        //     minWidth:120
        // },
        // {
        //     title:'新育成人代码',
        //     key:'newRelationCode',
        //     align:'center',
        //     minWidth:120
        // }, {
        //     title:'新育成人姓名',
        //     key:'newRelation',
        //     align:'center',
        //     minWidth:120
        // },
        {
          title: "生效日期",
          key: "effectiveDate",
          align: "center",
          minWidth: 100,
        },
        {
          title: "提交人",
          key: "createdUser",
          align: "center",
          minWidth: 110,
        },
        {
          title: "提交日期",
          key: "submissionDate",
          align: "center",
          minWidth: 100,
        },

        // {
        //     title:'审批日期',
        //     key:'approvalDate',
        //     align:'center',
        //     minWidth:100
        // },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            let status = "";
            if (params.row.status == 0) {
              status = "通过";
            } else if (params.row.status == 1) {
              status = "未通过";
            } else if (params.row.status == 2) {
              status = "审批中";
            } else if (params.row.status == 4) {
              status = "已撤回";
            } else if (params.row.status == 5) {
              status = "通过";
            } else {
            }
            return h("span", status);
          },
        },
        {
          title: "操作",
          key: "",
          fixed: "right",
          align: "center",
          minWidth: 300,
          render: (h, params) => {
            return h("div", [
              this.button.moveApply_seeRelationShip
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.quitApply("see", params.row);
                        },
                      },
                    },
                    "查看"
                  )
                : "",
              this.button.moveApply_editRelationShip
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        disabled:
                          params.row.status == 4 || params.row.status == 1
                            ? false
                            : true,
                      },
                      on: {
                        click: () => {
                          this.quitApply("edit", params.row);
                        },
                      },
                    },
                    "编辑"
                  )
                : "",
              this.button.moveApply_withdrawRelationShip
                ? h(
                    "Button",
                    {
                      props: {
                        type: "error",
                        size: "small",
                        disabled: params.row.status != 2 ? true : false,
                      },
                      on: {
                        click: () => {
                          this.withdraw(params.row);
                        },
                      },
                    },
                    "撤回"
                  )
                : "",
              this.button.moveApply_recordRelationShip
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        ghost: true,
                        size: "small",
                        disabled: params.row.approvalId ? false : true,
                      },
                      on: {
                        click: () => {
                          this.getAuditList(params.row);
                        },
                      },
                    },
                    "审批记录"
                  )
                : "",
            ]);
          },
        },
      ],
      //生效日期
      options1: {
        disabledDate(date) {
          const disabledDay = date.getDate();
          return disabledDay != 1;
        },
      },
      personList: [], // 业务员list
      stopClickLogin: false, //点击防抖,
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("moreCondition").style.display = "none";
      document.getElementById("upBtn").style.display = "none";
    });
  },
  created() {
    this.getPostList();
    // this.getLists();
    this.getRelationPage();
    if (
      !this.button.moveApply_withdrawRelationShip &&
      !this.button.moveApply_editRelationShip &&
      !this.button.moveApply_recordRelationShip
    ) {
      this.columns.pop();
    }
  },

  methods: {
    handleView(item) {
      console.log(item);
      window.open(
        this.$api.imgLoadUrl + item.filePath + "?sid=" + this.headers.sid
      );
    },
    delFormValidate_leaveImage() {
      this.formValidate_relation.changeAttachmentDTO = {};
    },
    // handSuccess(res,file,fileList){
    //     if(res.content.success){
    //         file.name=file.name.toLowerCase();
    //         if(file.name.indexOf('jpg')!=-1 ){
    //             res.content.content.files[0].type='0'
    //         }
    //         if(file.name.indexOf('pdf')!=-1){
    //             res.content.content.files[0].type='2'
    //         }
    //         if(file.name.indexOf('png')!=-1){
    //             res.content.content.files[0].type='1'
    //         }
    //         this.formValidate_relation.changeAttachmentDTO=res.content.content.files[0];
    //         this.formValidate_relation.changeAttachmentDTO.url=this.formValidate_relation.changeAttachmentDTO.filePath;
    //         console.log(this.formValidate_relation.changeAttachmentDTO);
    //     }else{
    //         this.$Message.error({
    //     content:  res.content.resultMessage ? res.content.resultMessage : res.message,
    //     duration: 8
    // });
    //     }
    // },
    //审批记录
    getAuditList(row) {
      this.$api
        .getActivityHis({ processInstanceId: row.approvalId })
        .then((res) => {
          if (res.respCode == 0) {
            this.auditModal = true;
            this.auditNo = row.approvalId;
            this.auditList = res.data;
          } else {
            this.$Message.error(res.message);
          }
        });
    },

    changeSize(size) {
      this.params.pageSize = size;
      this.getRelationPage();
    },
    //changepage
    changePage(page) {
      this.params.page = page;
      this.getRelationPage();
    },
    //删除文件
    delFormValidate_relationImage(item, index) {
      this.formValidate_relation.changeAttachmentDTO.splice(index, 1);
    },
    //上传文件
    handSuccess(res, file, fileList) {
      if (res.content.success) {
        file.name = file.name.toLowerCase();
        if (file.name.indexOf("jpg") !== -1) {
          file.type = "0";
        }
        if (file.name.indexOf("pdf") !== -1) {
          file.type = "2";
        }
        if (file.name.indexOf("png") !== -1) {
          file.type = "1";
        }
        console.log(res.content.content);
        res.content.content.files.map((item) => {
          item.url = item.filePath;
        });
        console.log(this.formValidate_relation);
        // res.content.content.files[0].url=t his.formValidate_relation.changeAttachmentDTO.filePath;
        this.formValidate_relation.changeAttachmentDTO.push(
          res.content.content.files[0]
        );
        console.log(this.formValidate_relation.changeAttachmentDTO);
        // this.formValidate_relation.changeAttachmentDTO
      } else {
        this.$Message.error({
          content: res.content.resultMessage
            ? res.content.resultMessage
            : res.message,
          duration: 8,
        });
      }
    },
    changeeffectiveDate(date) {
      this.formValidate_relation.changeRelationDTO.effectiveDate = date + "-01";
      console.log(this.formValidate_relation.changeRelationDTO.effectiveDate);
    },
    //查询重置
    reset() {
      // (this.params = {}), (this.params.date = []);
      this.$refs.paramsForm.resetFields();
      this.params.date = [];
      this.params.startDate = "";
      this.params.endDate = "";
      this.params.effectiveDate = "";
      this.search();
    },
    //查询search
    search() {
      this.params.page = 1;
      // delete this.params.date;
      this.getRelationPage();
    },
    //获取离职申请page
    getRelationPage() {
      //1提交日期 2 审批日期
      if (this.params.dateType == 1) {
        this.params.submissionFormDate = this.params.startDate;
        this.params.submissionToDate = this.params.endDate;
      } else {
        this.params.approvalFormDate = this.params.startDate;
        this.params.approvalToDate = this.params.endDate;
      }
      this.tableLoading = true;
      this.$api.getRelationPage(this.params).then((res) => {
        this.tableLoading = false;
        console.log(res);
        // 业务员下拉选
        this.getExcludeInActivity();
        if (res.respCode == 0) {
          this.data = res.data.list;
          this.total = res.data.total;
        } else {
          this.$Message.error(res.resultMessage);
        }
      });
    },
    //创建离职申请
    relationCreate(params) {
      console.log(params);
      //新推荐人代码和新育成人代码至少填写一项
      if (
        !(
          params.changeRelationDTO.newRecommenderCode ||
          params.changeRelationDTO.newRelationCode
        )
      ) {
        this.$Message.info({
          content: "新推荐人和新育成人至少填写一项",
          duration: 6,
        });
        return;
      }
      if (params.changeRelationDTO.effectiveDate) {
        if (typeof params.changeRelationDTO.effectiveDate !== "string") {
          params.changeRelationDTO.effectiveDate = this.$util.dateFormat2(
            new Date(params.changeRelationDTO.effectiveDate),
            "yyyy-MM-dd"
          );
        }
      }
      this.$api.relationCreate(params).then((res) => {
        console.log(res);
        if (res.respCode == 0) {
          this.$refs.formValidate_relation.resetFields();
          this.quitModalFlag = false;
          this.search();
        } else {
          this.$Message.error(res.resultMessage);
        }
      });
    },
    //提交
    submit(type) {
      this.stopClickLogin = true;
      setTimeout(() => {
        this.stopClickLogin = false;
      }, 2000);

      /*   if(this.formValidate_relation.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
      this.$refs.formValidate_relation.validate((item) => {
        if (item) {
          this.formValidate_relation.saveFlag = type;
          this.formValidate_relation.changeRelationDTO.oldRecommender =
            this.formValidate_relation.oldRecommender;
          this.formValidate_relation.changeRelationDTO.oldRecommenderCode =
            this.formValidate_relation.oldRecommenderCode;
          this.formValidate_relation.changeRelationDTO.oldRelation =
            this.formValidate_relation.oldRelation;
          this.formValidate_relation.changeRelationDTO.oldRelationCode =
            this.formValidate_relation.oldRelationCode;
          this.formValidate_relation.applyFrom = 0;
          this.relationCreate(this.formValidate_relation);
        }
      });
    },
    colseModal() {
      this.quitModalFlag = false;
    },
    cancel(form, flag) {
      if (!flag) {
        this.colseModal();
        this.$refs[form].resetFields();
      }
    },

    //获取所有列表
    getLists() {
      this.$util.getDeptByLevel(this, "3", (e) => {
        this.customList = e;
      });
      this.$util.getDeptByLevel(this, "4", (e) => {
        this.areaList = e;
      });
      this.$util.getDeptByLevel(this, "5", (e) => {
        this.teamList = e;
      });
      this.$util.getDeptByLevel(this, "6", (e) => {
        this.groupList = e;
      });
    },
    //获取职级列表
    getPostList() {
      this.$api
        .getPostList({
          enableStatus: 0,
        })
        .then((res) => {
          if (res.respCode == 0) {
            this.rankTypeList = res.data;
          }
        });
    },

    //再次提交
    resubmit(type) {
      this.stopClickLogin = true;
      setTimeout(() => {
        this.stopClickLogin = false;
      }, 2000);

      this.isEdit = true;
      this.formValidate_relation.changeType = "2";
      this.formValidate_relation.saveFlag = type;
      console.log(this.formValidate_relation);
      this.formValidate_relation.applyFrom = 0;
      //新推荐人代码和新育成人代码至少填写一项
      console.log(this.formValidate_relation.changeRelationDTO.newRecommender);
      console.log(this.formValidate_relation.changeRelationDTO.newRelation);
      // if (
      //   !(
      //     this.formValidate_relation.changeRelationDTO.newRecommender ||
      //     this.formValidate_relation.changeRelationDTO.newRelation
      //   )
      // ) {
      //   this.$Message.info({
      //     content: "新推荐人和新育成人至少填写一项",
      //     duration: 6,
      //   });
      //   return;
      // }
      /*   if(this.formValidate_relation.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
      this.$refs.formValidate_relation.validate((item) => {
        if (item) {
          if (this.formValidate_relation.changeRelationDTO.effectiveDate) {
            if (
              typeof this.formValidate_relation.changeRelationDTO
                .effectiveDate !== "string"
            ) {
              this.formValidate_relation.changeRelationDTO.effectiveDate =
                this.$util.dateFormat2(
                  new Date(
                    this.formValidate_relation.changeRelationDTO.effectiveDate
                  ),
                  "yyyy-MM-dd"
                );
            }
          }
          this.$api.resubmitRelation(this.formValidate_relation).then((res) => {
            if (res.respCode == 0) {
              this.$refs.formValidate_relation.resetFields();
              this.quitModalFlag = false;
              this.search();
            } else {
              this.$Message.error(
                res.content ? res.content : res.resultMessage
              );
            }
          });
        }
      });
    },

    //撤回
    withdraw(row) {
      this.$util.confirmDialog(
        this,
        "确认撤回",
        "确认撤回该条审批申请吗？一旦撤回将无法恢复!",
        (self) => {
          this.$api.withdraw({ id: row.id }).then((res) => {
            if (res.respCode == 0) {
              this.$Message.success("撤回成功");
              this.params.page = 1;
              this.getRelationPage();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },

    //获取人员详情 详情
    getDetail(row, type) {
      this.$api.relationDetail({ id: row.id }).then((res) => {
        if (res.respCode == 0) {
          this.isReady = type;
          this.formValidate_relation = res.data;
          this.formValidate_relation.agentCode = res.data.agentCode;
          this.formValidate_relation.approvalStatus = row.status;
          this.formValidate_relation.oldRecommender =
            this.formValidate_relation.changeRelationDTO.oldRecommender;
          this.formValidate_relation.oldRecommenderCode =
            this.formValidate_relation.changeRelationDTO.oldRecommenderCode;
          this.formValidate_relation.oldRelation =
            this.formValidate_relation.changeRelationDTO.oldRelation;
          this.formValidate_relation.oldRelationCode =
            this.formValidate_relation.changeRelationDTO.oldRelationCode;
          this.formValidate_relation.deptCodeAndName =
            res.data.ascriptionDeptName + "/" + res.data.ascriptionDept;
          this.quitModalFlag = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //modal显示
    quitApply(type, params) {
      this.isSee = false;
      this.formValidate_relation.changeAttachmentDTO = [];
      if (type === "add") {
        this.isReady = false;
        this.isEdit = false;
        this.quitModalFlag = true;
        this.formValidate_relation = {
          effectiveDate: "",
          oldRecommender: "", //原推荐人临时
          oldRecommenderCode: "", //原推荐人临时
          oldRelation: "", // "原育成人",
          oldRelationCode: "", // "原育成人编码",
          changeType: 2, //异动类型 1-离职；2-关系；3-调动；4-合并
          agentCode: "",
          agentName: "",
          deptCode: "",
          deptName: "",
          groupCode: "",
          groupName: "",
          teamCode: "",
          teamName: "",
          areaCode: "",
          areaName: "",
          postName: "",
          postCode: "",
          changeRelationDTO: {
            oldRecommender: "", //"原推荐人",
            oldRecommenderCode: "", // "原推荐人编码",
            oldRelation: "", // "原育成人",
            oldRelationCode: "", // "原育成人编码",
            newRecommender: "", // "新推荐人",
            newRecommenderCode: "", // "新推荐人编码",
            newRelation: "", //"新育成人",
            newRelationCode: "", //"新育成人编码"
            submitDate: "",
          },
          changeAttachmentDTO: [],
        };
      } else if (type === "ready") {
        this.isReady = true;
        this.isEdit = false;
        this.getDetail(params, true);
      } else if (type === "edit") {
        this.isEdit = true;
        this.isReady = false;
        this.getDetail(params, false);
      } else {
        this.isSee = true;
        this.getDetail(params, true);
      }
    },
    //获取下级机构
    getChildById(code, list, name, codeList, deptId) {
      this.getChild(code, deptId, this, (arr) => {
        this[list] = arr;
        if (list === "teamList") {
          this[list].map((item) => {
            if (item.marketCode === this.formValidate_relation.teamCode) {
              this.formValidate_relation.teamName = item.marketName;
            }
          });
        }
      });
    },
    //获取业务员
    getExcludeInActivity() {
      this.$api.excludeInActivity({}).then((res) => {
        if (res.result == 0) {
          this.personList = res.content;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //一键提交
    agentSbumit() {},
    //一键撤回
    agentCancel() {
      this.$util.confirmDialog(
        this,
        "确认提示",
        "确认继续此项操作吗？确认后将无法撤回",
        () => {
          this.$api.relation().then((res) => {
            if (res.result == 0) {
              this.params.page = 1;
              this.getRelationPage();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },

    //选择推荐关系人
    changeReferences(data, num) {
      if (num == "1") {
        this.formValidate_relation.changeRelationDTO.newRecommenderCode = data;
        this.formValidate_relation.changeRelationDTO.newRecommender =
          this.personList.find((item) => item.agentCode == data).agentName;
      }
    },
    //选择业务员
    changePerson(data) {
      let obj = this.personList.find((item) => item.agentCode == data);
      this.personList.find((item) => item.agentCode == data);
      // console.log(
      //   this.personList.includes((item) => item.agentCode ==data),

      //   " this.personList.includes((item) => item.agentCode == data)"
      // );
      this.formValidate_relation.agentCode = data;
      this.formValidate_relation.agentName = obj.agentName;
      this.formValidate_relation.deptCode = obj.ascriptionDept;
      this.formValidate_relation.deptName = obj.ascriptionDeptName;
      this.formValidate_relation.areaCode = obj.areaCode;
      this.formValidate_relation.areaName = obj.areaName;
      this.formValidate_relation.rankCode = obj.rankCode;
      this.formValidate_relation.rankName = obj.rankName;
      this.formValidate_relation.teamCode = obj.teamInfoCode;
      this.formValidate_relation.teamName = obj.teamInfoName;
      this.formValidate_relation.groupCode = obj.groupInfoCode;
      this.formValidate_relation.groupName = obj.groupInfoName;
      this.formValidate_relation.postCode = obj.postCode;
      this.formValidate_relation.postName = obj.postName;
      this.formValidate_relation.oldRecommender = obj.additionName;
      this.formValidate_relation.oldRecommenderCode = obj.additionCode;
      this.formValidate_relation.oldRelation = obj.cultivateName;
      this.formValidate_relation.oldRelationCode = obj.cultivateId;
      this.formValidate_relation.deptCodeAndName =
        obj.ascriptionDeptName + "/" + obj.ascriptionDept;
    },
    //changeRank 职级点击
    changeRank(data) {
      this.formValidate_relation.rankCode = data;
      this.formValidate_relation.rankName = this.rankTypeList.find(
        (item = item.rankCode == data)
      ).rankName;
    },
    //机构点击
    changeDept(data) {
      this.formValidate_relation.deptCode = data;
      this.formValidate_relation.deptName = this.transForList.customList.find(
        (item = item.rankCode == data)
      ).deptName;
    },
  },
  computed: {
    transForList() {
      return this.companyList;
    },
  },
  watch: {
    "formValidate_relation.agentCode"(m, v) {
      if (m) {
        //可能遇到change之后表单的校验不清除  所有需要重置一下 并赋值
        this.$refs.formValidate_relation.fields.forEach((e) => {
          if (e.prop == "agentCode") {
            e.resetField();
            this.formValidate_relation.agentCode = m;
          }
        });
      }
    },
    formValidate_relation(m, v) {
      if (m) {
        if (m.deptName) {
          m.deptCodeAndName = m.deptName + "/" + m.deptCode;
        }
      }
    },
    "formValidate_relation.deptCode"(o, v) {
      if (o) {
        this.getChildById(o, "areaList", "", "", 4);
      }
    },
    "formValidate_relation.areaCode"(o, v) {
      if (o) {
        this.getChildById(o, "teamList", "", "", 5);
      }
    },
    "formValidate.changeRelationDTO.newRecommenderCode"(n, o) {
      if (n == this.formValidate_relation.oldRecommenderCode) {
        this.$Message.info("原、新推荐人不能为同一人。");
      }
    },
    "formValidate.changeRelationDTO.newRelationCode"(n, o) {
      if (n == this.formValidate_relation.oldRelationCode) {
        this.$Message.info("原、新育成人不能为同一人。");
      }
    },
  },
};
</script>

<style scoped lang="less">
#quitApply {
  .header {
    display: -webkit-flex;
    display: flex;
    justify-content: space-around;
  }
  .ivu-input,
  .ivu-select,
  .ivu-date-picker {
    width: 162px;
  }
  .ivu-modal-body {
    max-height: 600px;
  }
}
.fileStyle /deep/ .ivu-form-item-error-tip {
  display: none !important;
}
</style>
